module.exports = __webpack_public_path__ + "static/media/doctor-male.cd57d2d8.png";